function shipchn() {
  setTimeout(function () {
    $.getJSON("/cart.js", function (cart) {
      var result = cart.total_price;
      var qntot = cart.item_count;
      var sp = 9900 - result;
      if (qntot == 0) {
        $(".prog").val(result);
        $(".cart_ship").text(
          "Add items to your bag to receive free shipping."
        );
      } else {
        if (sp > 0) {
          $(".prog").val(result);
          $(".cart_ship").text(
            "You're " +
              Shopify.formatMoney(sp) +
              " away from free shipping!"
          );
        } else if (sp <= 0) {
          $(".prog").val(result);
          $(".cart_ship").text("Your bag qualifies for free shipping!");
        }
      }
      $(".pb").load(" .pb > *");
    });
    $(".custom-add-size-modal-wrap").attr("style", "").removeClass("show-sizes").find(".custom-size-heading").text("Select Size");
    $(".adc_col").attr("style", "");
  }, 5500);
}
function changeswatch(e, k) {
  $(".varsel" + k).val(e.value);
}
function changedrop(m, n) {
  $(".varsw" + n).val(m.value);
}
function redi(p) {
  location.href = p;
}
function op(u) {
  nex = u.nextElementSibling;
  nex.style.display = "";
  u.style.display = "";
}
function clmod(d) {
  d.parentElement.style.display = "none";
  d.parentElement.previousElementSibling.style.display = "";
}

function findSizeModal(startEl) {
  var el = startEl.nextElementSibling;
  while (el) {
    if (el.classList.contains('custom-add-size-modal-wrap')) return el;
    el = el.nextElementSibling;
  }
  var parent = startEl.closest('.grid-product__image-mask, .ss__result__image__wrapper, .grid-product__content, .custom_grid-content');
  return parent ? parent.querySelector('.custom-add-size-modal-wrap') : null;
}

function dedupSizeButtons(modal) {
  var btns = modal.querySelectorAll('button.size-values');
  var seen = {};
  btns.forEach(function(b) {
    var label = b.textContent.trim();
    if (seen[label]) {
      seen[label].style.setProperty('display', 'none', 'important');
    }
    seen[label] = b;
    b.style.display = '';
  });
}

function openSizeModal(button) {
  if (typeof event !== 'undefined' && event) {
    event.stopPropagation();
    event.preventDefault();
  }
  var modal = findSizeModal(button);
  if (!modal) return;
  dedupSizeButtons(modal);
  var heading = modal.querySelector('.custom-size-heading');
  if (heading) heading.textContent = 'Select Size';
  modal.style.display = 'block';
  modal.style.opacity = '1';
  modal.style.visibility = 'visible';
  button.style.setProperty('display', 'none', 'important');
  button.style.setProperty('opacity', '0', 'important');
  button.style.setProperty('visibility', 'hidden', 'important');
}

function closeSizeModal(closeButton) {
  if (typeof event !== 'undefined' && event) {
    event.stopPropagation();
    event.preventDefault();
  }
  var modal = closeButton.parentElement;
  if (!modal) return;
  var heading = modal.querySelector('.custom-size-heading');
  if (heading) heading.textContent = 'Select Size';
  modal.style.display = 'none';
  modal.style.opacity = '0';
  modal.style.visibility = 'hidden';
  var container = modal.parentElement;
  var quickAddButton = container ? container.querySelector('button.adc_col') : null;
  if (quickAddButton) {
    quickAddButton.style.removeProperty('display');
    quickAddButton.style.removeProperty('opacity');
    quickAddButton.style.removeProperty('visibility');
  }
}
function collectionchangeswatch(h, j, template) {
  var variant_id = j;
  $(".custom-error").addClass("hidden");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: 1,
      id: variant_id,
    },
    dataType: "json",
    success: function (data) {
        if (h && h.blur) h.blur();
        var $heading = $(h).closest('.custom-add-size-modal-wrap').find('.custom-size-heading');
        if ($heading.length) $heading.text('Added to bag!');
        $.getJSON("/cart.js", function (data) {
          check_cart();
          if(template != 'cart'){
          document.dispatchEvent(new CustomEvent("cart:build"));
          $(".pb").load(" .pb > *");
          $("#cart_ship").load(" #cart_ship > *");
          $("#cart--count").load(" #cart--count > *");
          setTimeout(function() {
            $("#CartDrawer").addClass("drawer--is-open");
            document.body.style.overflow = 'hidden';
            $(".appear-animation").css("opacity", 1);
            $(".appear-animation").css("transform", "translateY(0px)");
          }, 1000);
          }else{
            location.reload();
          }
        });
    },
    error: function (error) {
      $(".custom-error").removeClass("hidden");
      $(".custom-error").text(error.responseJSON.description);
    },
  });
}
$(".drawer__close-button").click(function () {
  $("#CartDrawer").removeClass("drawer--is-open");
  // Restore scroll
  document.body.style.overflow = 'auto';
});

// Global delegated handler for ALL .adc_col quick-add buttons.
// Uses the same openSizeModal / closeSizeModal / collectionchangeswatch flow
// that the working Liquid-rendered carousels use, so every carousel and grid
// behaves identically regardless of whether the HTML came from Liquid or
// SearchSpring.
document.addEventListener('click', function(e) {
  var btn = e.target.closest('button.adc_col');
  if (!btn) return;
  // If the button already has an inline onclick attribute (Liquid-rendered),
  // the browser already invoked it — nothing more to do.
  if (btn.hasAttribute('onclick')) return;

  e.stopPropagation();
  e.preventDefault();

  var sizeModal = findSizeModal(btn);
  if (sizeModal) {
    openSizeModal(btn);
  } else {
    var product = btn.closest('[data-product-id]');
    if (!product) return;
    var inner = product.querySelector('[data-variant-id]');
    if (inner) {
      var formData = new FormData();
      formData.set('id', inner.dataset.variantId);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function(r) { if (r.ok && typeof openCartDrawer === 'function') openCartDrawer(); })
        .catch(function() { alert('There was a problem adding this product to the bag.'); });
    }
  }
});

// Global delegated handler for close buttons inside size modals.
// Mirrors the delegated close handler pattern so it works even after
// SearchSpring re-renders replace DOM elements.
document.addEventListener('click', function(e) {
  var closeBtn = e.target.closest('button.cl_mod');
  if (!closeBtn) return;
  if (closeBtn.hasAttribute('onclick')) return;

  e.stopPropagation();
  e.preventDefault();
  closeSizeModal(closeBtn);
});

$(".sl_responsive").slick({
  arrow: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  infinite: true,
  prevArrow:
    '<span class="prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path></svg></span>',
  nextArrow:
    '<span class="next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path></svg></span>',

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: "unslick",
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

if (screen.width < 480) {
  $(".gs").removeClass("sl_responsive");
}
